// extracted by mini-css-extract-plugin
export default {"label":"vacancyDetailsLabel_label__5IFvp","urgentLabel":"vacancyDetailsLabel_urgentLabel__igZF1"};